import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import NavBarNew from "../NavBarNew";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { positions, useAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";
import {
  updateEmpatheticPrompt,
  updateProfessionalPrompt,
  updateDataDrivenPrompt,
} from "../features/messagingConfig/messagingConfigSlice";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import EditIcon from "@mui/icons-material/Edit";
import PriceCalculator from "./PriceCalculator";

const Prompts = () => {
  const alert = useAlert();
  const { empathetic, professional, data_driven } = useSelector(
    (state) => state.messagingConfig
  );
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [open, setOpen] = useState(false);
  const [showPrompt, setShowPrompt] = useState(true);
  const [error, setError] = useState("");
  const [readyOnly, setReadOnly] = useState({
    family: true,
    hospital: true,
    data: true,
  });

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // setError("");
    // if (password === "Niroggyan@2022") {
    //   setShowPrompt(true);
    //   setOpen(false);
    // } else {
    //   setError("Invalid password");
    //   setShowPrompt(false);
    // }
  };

  const passwordSection = () => {
    return (
      <Dialog
        fullWidth
        open={open}
        disableEscapeKeyDown
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
      >
        <DialogContent>
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <form onSubmit={handleSubmit}>
            <Typography variant="h8" mb={2}>
              Enter your password
            </Typography>
            <TextField
              fullWidth
              maxWidth="sm"
              id="outlined-basic"
              label=""
              variant="outlined"
              size="small"
              value={password}
              placeholder="Enter password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <Typography
              sx={{ fontSize: "12px", color: "red", display: "block" }}
              mt={1}
            >
              {error}
            </Typography>
            <Button type="submit" className="mt-3">
              Submit
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    );
  };

  const handleDisabled = (key) => {
    setReadOnly((prev) => ({ ...prev, [key]: false }));
  };

  const handlePostEdit = (key) => {
    setReadOnly((prev) => ({ ...prev, [key]: true }));
  };

  // useEffect(() => {
  //   setShowPrompt(false);
  //   setOpen(true);
  // }, []);

  return (
    <Box>
      <NavBarNew />
      <Box sx={{ padding: "0px 8%" }} mt={3}>
        {passwordSection()}
        {showPrompt ? (
          <Box>
            <Box>
              <Typography variant="h7">Prompts</Typography>
              <Typography sx={{ fontSize: "14px", display: "block" }} mt={1}>
                *Note: Please dont edit age, gender & cohort_summary fields in
                the below prompts.
              </Typography>
              <Stack gap={2} mt={3} pb={2}>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography variant="h8">Family Physician 👨🏽‍⚕️</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack alignItems={"flex-end"} pr={2}>
                      <Typography
                        mr={1.5}
                        sx={{
                          cursor: "pointer",
                          fontSize: "14px",
                          "&:hover": { color: "blue" },
                        }}
                        onClick={() => handleDisabled("family")}
                      >
                        Edit
                      </Typography>
                    </Stack>
                    <TextField
                      id="outlined-multiline-flexible"
                      label=""
                      multiline
                      rows={6}
                      fullWidth
                      disabled={readyOnly.family}
                      sx={{ fontSize: "16px" }}
                      value={empathetic}
                      onChange={(e) =>
                        dispatch(updateEmpatheticPrompt(e.target.value))
                      }
                      onBlur={() => handlePostEdit("family")}
                    />
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography variant="h8">Corporate Hospital 🏥</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack alignItems={"flex-end"} pr={2}>
                      <Typography
                        mr={1.5}
                        sx={{
                          cursor: "pointer",
                          fontSize: "14px",
                          "&:hover": { color: "blue" },
                        }}
                        onClick={() => handleDisabled("hospital")}
                      >
                        Edit
                      </Typography>
                    </Stack>
                    <TextField
                      id="outlined-multiline-flexible"
                      label=""
                      multiline
                      rows={6}
                      fullWidth
                      sx={{ fontSize: "16px" }}
                      disabled={readyOnly.hospital}
                      value={professional}
                      onChange={(e) =>
                        dispatch(updateProfessionalPrompt(e.target.value))
                      }
                      onBlur={() => handlePostEdit("hospital")}
                    />
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography variant="h8">Data Driven 👨🏽‍💻</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack alignItems={"flex-end"} pr={2}>
                      <Typography
                        mr={1.5}
                        sx={{
                          cursor: "pointer",
                          fontSize: "14px",
                          "&:hover": { color: "blue" },
                        }}
                        onClick={() => handleDisabled("data")}
                      >
                        Edit
                      </Typography>
                    </Stack>
                    <TextField
                      id="outlined-multiline-flexible"
                      label=""
                      multiline
                      rows={6}
                      sx={{ fontSize: "16px" }}
                      fullWidth
                      disabled={readyOnly.data}
                      value={data_driven}
                      onChange={(e) =>
                        dispatch(updateDataDrivenPrompt(e.target.value))
                      }
                      onBlur={() => handlePostEdit("data")}
                    />
                  </AccordionDetails>
                </Accordion>
              </Stack>
            </Box>
            <Box>
              <PriceCalculator />
            </Box>
          </Box>
        ) : (
          <Box>
            <Typography variant="h7">No data</Typography>
            <Typography
              mt={1}
              sx={{
                color: "blue",
                display: "block",
                fontSize: "14px",
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
              onClick={() => setOpen(true)}
            >
              View Prompts
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Prompts;
